import React, { useState, useEffect } from "react";
import {
  SlSelect,
  SlOption,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import YearCalendar from "../../shared/YearlyCalendar";
import API from "../../services/api";
import { useSelector } from "react-redux";
import ScrollContainer from "react-indiana-drag-scroll";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import * as XLSX from "xlsx";
import { getBrandOptions, toLakhs } from "../../utils/constants";
function SalesTasks() {
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [newsPapers, setNewsPapers] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const selectedYear = useSelector((state) => state.Head.selectedYear);
  let thisyear=new Date(selectedYear).getFullYear();


  const year = new Date(selectedYear).getFullYear() % 100;

  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
const [selectedType, setSelectedType] = useState("all");
const [userType, setUserType] = useState(-1);
  const fetchNewspapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewsPapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getdownloadData = () => {
    setDownloadLoader(true);
    try {
      let subHeaders = Array.from(
        { length: 3 },
        (_, index) => ["No of Clients",
        "No of Insertions",
        "Revenue",
        "Revenue / Insertion"]
      );
      subHeaders = subHeaders.flat();
      let headers = [
        [
          "Category",
          "Deployed Accounts",
          `${selectedNewspaper}(Dec${year - 2} to Nov${year - 1})`,
          "",
          "",
          "",
          ` W2N(Jan${year - 1} to Dec${year - 1})`,
          "",
          "",
          "",
          ` W2N(Jan${year} to Dec${year})`,
          "",
          "",
          "",
          "Sales Tasks (No.of Clients)",
          "",
          "",
        ],
        [
          "","",
          ...subHeaders,
          "New Conversion",
          "New Revenue",
          "Increase Revenue / Insertion",
        ],
      ];
      const tableData = data.map((item) => [
        item.category || "",
        item.deployedAccounts || "",
        item.newsPaperBrandCount || 0,
        item.totalNewspaperInsertions || 0,
        item.totalNewspaperRevenue || 0,
        
          item.totalNewspaperRevenue / item.totalNewspaperInsertions || 0
        ,
        item.way2newsBrandCount || 0,
        item.totalWay2newsInsertions || 0,
        item.totalWay2newsRevenue || 0,
        item.totalWay2newsRevenue / item.totalWay2newsInsertions || 0,
        item[`way2newsBrandCount_${thisyear}`] || 0,
        item[`totalWay2newsInsertions_${thisyear}`]|| 0,
        item[`totalWay2newsRevenue_${thisyear}`] || 0,
        item[`totalWay2newsRevenue_${thisyear}`] / item[`totalWay2newsInsertions_${thisyear}`] || 0,
        "", // Placeholder for new conversions
        "", // Placeholder for increase insertions
        "", // Placeholder for increase revenue/insertion
      ]);
      const aoa = [...headers, ...tableData];
      const merges = []
      merges.push({ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } });
      merges.push({ s: { r: 0, c: 1 }, e: { r: 1, c: 1 } });
      merges.push({ s: { r: 0, c: 2 }, e: { r: 0, c: 5 } });
      merges.push({ s: { r: 0, c: 6 }, e: { r: 0, c: 9 } });
      merges.push({ s: { r: 0, c: 10 }, e: { r: 0, c: 13 } });
      merges.push({ s: { r: 0, c: 14 }, e: { r: 0, c: 16 } });
      const worksheet = XLSX.utils.aoa_to_sheet(aoa);
      worksheet["!merges"] = merges;
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "SalesTasks");

      // Write the Excel file and trigger download
      XLSX.writeFile(workbook, `SalesTasks_${year}.xlsx`);
    } catch (error) {
      console.error(error);
    } finally {
      setDownloadLoader(false);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/plansummary/salesTasks",
        method: "POST",
        responseType: "json",
        data: {
          year: selectedYear,
          newsPaper: selectedNewspaper,
          type: selectedType
        },
      });
      if (res.code === 200) {
        setUserType(res.data[0]?.userType)
        setData(res.data?.filter((item) => item?.category !== null));
        if(res.data?.[0]?.userType !== -1){
          setSelectedType(`${res.data?.[0]?.userType}`)
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchNewspapers();
  }, []);

  useEffect(() => {
    fetchData();
  }, [selectedNewspaper, selectedYear,selectedType]);

  return (
    <>
      <div className="d-flex gap-3 justify-end items-center my-2">
      <SlSelect size="small" value={selectedType} label="Team" onSlChange={(e) => {setSelectedType(e.target.value)}}>
      {userType === -1 ? <SlOption value='all'>All</SlOption> : null}
          {getBrandOptions(userType, localStorage.getItem('email'))?.map((type) => (
            <SlOption key={type.value} value={type.value}>{type.label}</SlOption>
          ))}
        </SlSelect>
        <SlSelect
          placeholder="NewsPaper"
          value={selectedNewspaper}
          onSlChange={(e) => setSelectedNewspaper(e.target.value)}
        >
          {newsPapers.map((item) => (
            <SlOption key={item.name} value={item.name}>
              {item.name}
            </SlOption>
          ))}
        </SlSelect>
        <YearCalendar startYear={2023} endYear={2100}></YearCalendar>
        {downloadLoader ? (
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        ) : (
          <div
            className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
            onClick={getdownloadData}
          >
            <sl-tooltip content="Download" placement="top">
              <SlIcon library="lucide" name="download" />
            </sl-tooltip>
          </div>
        )}
      </div>
      <ScrollContainer>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th rowSpan={2}>Category</th>
              <th rowSpan={2}>Deployed Accounts</th>
              <th colSpan={4}>
                {selectedNewspaper}(Dec{year - 2} to Nov{year - 1})
              </th>
              <th colSpan={4}>
                W2N(Jan{year - 1} to Dec{year - 1})
              </th>
              <th colSpan={4}>
                W2N(Jan{year} to Dec{year})
              </th>
              <th colSpan={3}>Sales Task(No.of clients)</th>
            </tr>
            <tr>
              {Array.from({ length: 3 }).map((_, index) => {
                return (
                  <>
                    <th>No.of clients</th>
                    <th>Insertions</th>
                    <th>Revenue</th>
                    <th>Revenue / Insertion</th>
                  </>
                );
              })}
              <th>New Conversions</th>
              <th>Increase Insertions</th>
              <th>Increase Revenue / Insertion</th>
            </tr>
          </thead>
          {!loader && data.length > 0 ? (
            <tbody>
              {data.map(
                (item, index) =>
                
                  item.category && (
                    <tr key={item.category}>
                      <td>{item.category}</td>
                      <td>{item.deployedAccounts || ""}</td>
                      <td>{item.newsPaperBrandCount}</td>
                      <td>{item.totalNewspaperInsertions}</td>
                      <td>{toLakhs(item.totalNewspaperRevenue)}</td>
                      <td>
                        {toLakhs(
                          (item.totalNewspaperRevenue /
                            item.totalNewspaperInsertions) || 0
                        )}
                      </td>
                      <td>{item.way2newsBrandCount}</td>
                      <td>{item.totalWay2newsInsertions}</td>
                      <td>{toLakhs(item.totalWay2newsRevenue)}</td>
                      <td>
                        {toLakhs(
                          (item.totalWay2newsRevenue /
                            item.totalWay2newsInsertions) || 0
                        )}
                      </td>
                      <td>{item[`way2newsBrandCount_${thisyear}`]}</td>
                      <td>{item[`totalWay2newsInsertions_${thisyear}`]}</td>
                   
                      <td>{toLakhs(item[`totalWay2newsRevenue_${thisyear}`])}</td>
                      <td>
                        {toLakhs(
                          (item[`totalWay2newsRevenue_${thisyear}`] / item[`totalWay2newsInsertions_${thisyear}`]) || 0
                        )}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  )
              )}
            </tbody>
          ) : loader ? (
            <TableLoader colspan={17} />
          ) : (
            <NoDataFound colspan={17} />
          )}
        </table>
      </ScrollContainer>
    </>
  );
}

export default SalesTasks;
